var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex pt-6"},_vm._l((5),function(_,index){return _c('div',{key:index},[_c('img',{staticClass:"max-w-5 max-h-5 pr-2",attrs:{"src":require("@/assets/images/star.png"),"alt":"rating star"}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }